import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@components/button';
import { CsIconModule } from '@components/icon';
import { NotificationPermissionSheetComponent } from './notification-permission-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    CsIconModule,
    FormsModule,
  ],
  declarations: [NotificationPermissionSheetComponent],
  exports: [NotificationPermissionSheetComponent],
})
export class NotificationPermissionSheetModule { }
